window.addEventListener('DOMContentLoaded', () => {
  const showSizeGuide = new URLSearchParams(window.location.search).get('sizeguide')

  if (showSizeGuide !== null) {
    const table = showSizeGuide === 'new' ? 'new-table' : 'old-table'
    triggerSizeGuide(table, null, 'sizing-guide-modal')
  }

  document.body.addEventListener('click', (eventClick) => {
    const table = eventClick.target.hasAttribute('data-new-size-product') ? 'new-table' : 'old-table'
    triggerSizeGuide(table, eventClick, null)
  })

  function triggerSizeGuide (table, eventClick, openModalManual) {
    const theModalID = document.getElementById('sizingGuideModal')
    const bodyClass = document.querySelector('body')
    const theTriggersAttributeValue = 'sizing-guide-modal'
    const modalInner = document.getElementById('global__popup__modal__overlay')

    let openModal = ''
    let closeModal = ''
    let clickInside = ''

    if (eventClick) {
      openModal = eventClick.target.getAttribute('global_popup_modal_open')
      closeModal = eventClick.target.getAttribute('global_popup_modal_close')
      clickInside = modalInner.id === eventClick.target.id
    } else {
      openModal = openModalManual
    }

    if (openModal === theTriggersAttributeValue) {
      if (table === 'new-table') {
        theModalID.classList.add('new-table')
        theModalID.classList.remove('old-table')
      } else {
        theModalID.classList.add('old-table')
        theModalID.classList.remove('new-table')
      }

      theModalID.style.zIndex = 1000
      theModalID.classList.add('global__popup-modal--show')
      theModalID.classList.remove('global__popup-modal--hide')
      bodyClass.classList.toggle('is-modal-open')
    }

    if (closeModal === theTriggersAttributeValue) {
      theModalID.classList.remove('global__popup-modal--show')
      theModalID.classList.add('global__popup-modal--hide')
      bodyClass.classList.toggle('is-modal-open')
    }

    // close modal from anywhere outside
    if (clickInside) {
      theModalID.classList.remove('global__popup-modal--show')
      theModalID.classList.add('global__popup-modal--hide')
      bodyClass.classList.toggle('is-modal-open')
    }
  }
})
